// src/features/delegations/constants/delegationStatuses.js

export const DELEGATION_STATUS_COLOR = {
  DRAFT: 'default',
  ACTIVE: 'success',
  UNDER_REVIEW: 'warning',
  ARCHIVED: 'default',
};

export const DELEGATION_STATUSES = ['DRAFT', 'ACTIVE', 'UNDER_REVIEW', 'ARCHIVED'];
